import { render, staticRenderFns } from "./client-list.vue?vue&type=template&id=cb6d5566&scoped=true"
import script from "./client-list.vue?vue&type=script&lang=js"
export * from "./client-list.vue?vue&type=script&lang=js"
import style0 from "./client-list.vue?vue&type=style&index=0&id=cb6d5566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d5566",
  null
  
)

export default component.exports